
import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function InsiderModel() {

    const apiModel = ChartstwitsRepository();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('sold');
    const [initialDisplayCount, setInitialDisplayCount] = useState(100);
    const [tickersearchdata, setsearchdata] = useState({
        search: ''
    });

    const [lstInsiders, setInsiders] = useState([{
        name: "",
        change: "",
        filingDate: "",
        share: "",
        symbol: "",
        source: "",
        transactionDate: "",
        transactionPrice: ""
    }])

    const [lstFilterInsiders, setFilterInsiders] = useState([{
        name: "",
        change: "",
        filingDate: "",
        share: "",
        symbol: "",
        source: "",
        transactionDate: "",
        transactionPrice: ""
    }])

    const [lstInsidersTickers, setInsidersTickers] = useState([{
        name: "",
        change: "",
        filingDate: "",
        share: "",
        symbol: "",
        source: "",
        transactionDate: "",
        transactionPrice: ""
    }])

    const selectTab = (e: any) => {
        debugger;
        setActiveTab(e);

        if (e == 'sold') {
            sold();
        } else if (e == 'bought') {
            bought();
        }
    }

    const getInsiders = async () => {
        debugger;
        setInsiders([]);
        const responseData: any = await apiModel.getInsiderDetails();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setInsiders(responseData);
            let data = responseData.filter((x: any) => (+x.change < 0) || x.Type === 'Advertise');
            setFilterInsiders(data)
        }
    }

    const sold = () => {
        debugger;
        setFilterInsiders([]);
        let data = lstInsiders.filter((x: any) => (+x.change < 0) || x.Type === 'Advertise');
        setFilterInsiders(data)
    }

    const bought = () => {
        debugger;
        setFilterInsiders([]);
        let data = lstInsiders.filter((x: any) => (+x.change >= 0) || x.Type === 'Advertise');
        setFilterInsiders(data)
    }

    const sliceMainDataArray = () => {
        const slicedData = lstFilterInsiders.slice(0, initialDisplayCount);
        setInsidersTickers(slicedData);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        debugger;
        setInsidersTickers([]);
        const searchdata = e.target.value;
        setsearchdata({ 'search': searchdata });
    }

    useEffect(() => {
        getInsiders();
    }, [])

    useEffect(() => {
        // debugger;
        if (tickersearchdata.search == '') {
            sliceMainDataArray();
        } else {
            let searchResults = lstFilterInsiders.filter((x: any) => (x.symbol.toLowerCase().includes(tickersearchdata.search)));
            setInsidersTickers(searchResults)
        }
    }, [lstInsidersTickers, lstFilterInsiders])


    useEffect(() => {
        if (tickersearchdata.search == '') {
            setInitialDisplayCount(100)
            sliceMainDataArray();
        } else {
            let searchResults = lstFilterInsiders.filter((x: any) => (x.symbol.toLowerCase().includes(tickersearchdata.search)));
            debugger;
            setInsidersTickers(searchResults)
        }
    }, [tickersearchdata])


    useEffect(() => {
        debugger;
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight
            ) {
                setInitialDisplayCount(prevCount => prevCount + 100);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    const back = () => {
        debugger;
        navigate(`/dashboard`);
    }

    return { lstFilterInsiders, activeTab, selectTab, sold, bought, back, lstInsidersTickers, handleChange }
}